"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComparisonProductSelectorItem = _interopRequireDefault(require("./ComparisonProductSelectorItem"));
var _r10SourceLibrary = require("r10-source-library");
var _useComparison2 = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ProductSelectorWrapper = (0, _styledComponents.default)((0, _BaseComponents.GrayBackground)('div'))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-bottom: 32px;\n"])));
var ComparisonProductSelector = function ComparisonProductSelector() {
  //Here I want the products to be displayed which can be created from the comparableProducts and the displayedProducts
  var _useComparison = (0, _useComparison2.default)(),
    products = _useComparison.products,
    displayedProducts = _useComparison.displayedProducts,
    updateCurrentSelectedProducts = _useComparison.updateCurrentSelectedProducts,
    onProductSelect = _useComparison.onProductSelect,
    notSelectedProducts = _useComparison.notSelectedProducts;
  var selectOptionFactory = function selectOptionFactory(productId) {
    return [products[productId]].concat(_toConsumableArray(notSelectedProducts)).map(function (product) {
      return {
        text: product.productName,
        value: product.productId
      };
    });
  };
  return /*#__PURE__*/_react.default.createElement(ProductSelectorWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true
  }, displayedProducts.map(function (productId) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: productId
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_ComparisonProductSelectorItem.default, {
      selectedProduct: products[productId],
      setSelectedProduct: updateCurrentSelectedProducts,
      onSelect: onProductSelect,
      selectOptions: selectOptionFactory(productId)
    })));
  })));
};
var _default = ComparisonProductSelector;
exports.default = _default;